export default __webpack_public_path__ + "static/media/youtube.e52d913e.svg";